import React from "react";
import LoaderComponent from "../../Loader";

const CompanyLogoSection = ({
  profileFullImage,
  isDefaultProfileImage,
  isImgLoading,
  setIsImgLoading,
  setIsModal,
  setIsConfirmation,
}) => (
  <div className="form-row mb__18">
    <label className="gridEven col-md-3">Company Logo</label>
    <span className="rowFlex gridOdd col-md-9">
      <div className="mr__1">
        <img
          style={{ visibility: isImgLoading ? "hidden" : "" }}
          onLoad={() => setIsImgLoading(false)}
          onError={() => setIsImgLoading(false)}
          className="profilePic"
          src={profileFullImage}
          id="imgProfileImage"
          alt="Organization logo"
        />
        {isImgLoading && <LoaderComponent />}
      </div>
      <div className="colFlex line-height__1">
        <div className="rowFlex">
          <span className="mr">
            <button
            type="button"
            className="pointer mr__1 btn-cc btn-cc__transparent btn-cc__link__blue"
            onClick={() => setIsModal(true)}
          >
            {isDefaultProfileImage ? "Upload a logo" : "Change Logo"}
          </button>
          </span>
          {!isDefaultProfileImage && (
            <button
              type="button"
              className="pointer btn-cc btn-cc__transparent btn-cc__link__blue"
              onClick={() => setIsConfirmation(true)}
            >
              Remove
            </button>
          )}
        </div>
        <label className="mt">
          {isDefaultProfileImage && `No files uploaded yet. `}Upload a file that is more than 120px wide and 120px length
        </label>
      </div>
    </span>
  </div>
);

export default CompanyLogoSection;
